module.exports = __webpack_public_path__ + "static/TroisMilleBold-18-a66b718489021781c697e7c51bf541b7.woff";